export enum EngineList {
    WebKit = 'WebKit',
    Google = 'Google Speech',
    Watson = 'IBM Watson',
    Whisper = 'OpenAI Whisper',
    DeepGram = 'DeepGram',
    Transcribe = 'AWS Transcribe'
}

export enum EngineKeyToNameMap {
    engine1 = EngineList.WebKit,
    engine2 = EngineList.Google,
    engine3 = EngineList.Watson,
    engine4 = EngineList.Whisper,
    engine5 = EngineList.DeepGram,
    engine6 = EngineList.Transcribe
}